import logo from "@/assets/falkors-walls-logo.png";

const Footer = () => {
  return (
    <footer className="py-12 bg-charcoal text-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          <div>
            <img src={logo} alt="Falkors Walls - Expert Climbing Gym Construction Company and Commercial Climbing Wall Contractors" className="h-12 w-auto mb-2" />
            <p className="text-white/70 mt-2">
              World-Class Climbing Gym Construction
            </p>
          </div>
          
          <div className="text-center md:text-right">
            <p className="text-white/70">
              © {new Date().getFullYear()} Falkors Group. All rights reserved.
            </p>
            <p className="text-sm text-white/50 mt-1">
              Building climbing facilities across Europe since 2009
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;